import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  reviewsPageBuy: {
    id: 'reviewsPage.buy',
    defaultMessage: 'Koupit',
  },
});
